import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TransactionGroup from './TransactionGroup';
import LoaderComponent from '../../common/LoaderComponent';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { StandardBody } from 'web-ui-components/lib/typography/body';
class TransactionGridComponentMobile extends React.Component {
  constructor(props) {
    super(props);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSwipeLeft = this.onSwipeLeft.bind(this);
    this.onSwipeRight = this.onSwipeRight.bind(this);
    this.state = {
      mobileRowSelectCount: 0,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (!nextProps.showSelectionTag && this.props.showSelectionTag) {
      this.setState({ mobileRowSelectCount: 0 });
    }
  }
  onRowSelect(data, value) {
    if (value) {
      this.setState({
        mobileRowSelectCount: this.state.mobileRowSelectCount + 1,
      });
    } else {
      this.setState({
        mobileRowSelectCount: this.state.mobileRowSelectCount - 1,
      });
    }
    this.props.onRowSelect(data, value);
  }
  getTransactionGroup() {
    const transactionGroup = [];
    const dates = [];
    _.map(_.uniqBy(this.props.transactions, 'date'), (data) => {
      dates.push(data.date);
    });
    _.map(dates, (date) => {
      const transactions = _.filter(this.props.transactions, (data) => {
        return data.date === date;
      });
      transactionGroup.push(
        <TransactionGroup
          {...this.props}
          data={transactions}
          date={date}
          showSelectionTag={this.props.showSelectionTag}
          onRowSelect={this.onRowSelect}
          rowCustomClass={this.props.rowCustomClass}
          onTableTagClick={this.props.onTableTagClick}
          rowClickIndex={this.props.rowClickIndex}
          openTransactionInProgressPopUp={
            this.props.openTransactionInProgressPopUp
          }
          onSwipeLeft={this.onSwipeLeft}
          onSwipeRight={this.onSwipeRight}
        />
      );
    });
    return transactionGroup;
  }
  onSwipeLeft() {
    if (this.refs['dataGroup']) {
      this.refs['dataGroup'].classList.toggle('swiped', true);
    }
  }
  onSwipeRight() {
    if (this.refs['dataGroup']) {
      this.refs['dataGroup'].classList.toggle('swiped', false);
    }
  }
  render() {
    let transactionsGrid;
    let disableSelectedRowTag = '';
    let noDataText =
      'No transactions found. You can only see your last three months’ transactions using your mobile device.';
    this.props.transactionReadFlag
      ? (noDataText =
          'No transactions found. You can only see your last three months’ transactions using your mobile device.')
      : (noDataText =
          "Sorry but it's not possible to show payments for this account type.");
    if (this.props.transactions.length > 0) {
      if (this.props.loadTransactionsFlag) {
        transactionsGrid = (
          <Inline.Centered
            nodes={[
              <ActionButton.Primary
                labelText="Show more"
                onClick={this.props.loadNextTransactions}
              />,
            ]}
          />
        );
      } else {
        transactionsGrid = (
          <div className="callout callout__full callout__txt-center">
            <StandardBody>
              <p>
                That’s all we can find. You can only see your last three months’
                transactions using your mobile device.
              </p>
            </StandardBody>
          </div>
        );
      }
    }
    if (this.state.mobileRowSelectCount === 0) {
      disableSelectedRowTag = 'disable-link';
    }

    let displayPage;
    if (this.props.isLoading && !this.props.transactionServiceErrorFlag) {
      displayPage = (
        <div ref="dataGroup" className="datatable type--jura">
          <LoaderComponent type="small" />
        </div>
      );
    } else if (this.props.transactionServiceErrorFlag) {
      displayPage = (
        <div ref="dataGroup" className="datatable type--jura">
          <div className="u-text-center">
            <div>
              {this.props.statusErrorResponse === 408
                ? this.props.content.transactionsErrorBody
                : this.props.transactionServiceErrorMessage}
            </div>
            <button
              className="c-btn c-btn--default"
              onClick={this.props.onRetryClick}
            >
              {this.props.statusErrorResponse === 408
                ? this.props.content.transactionsErrorButtonTitle
                : 'Retry'}
            </button>
          </div>
        </div>
      );
    } else {
      displayPage = (
        <div ref="dataGroup" className="datatable type--jura">
          {this.props.transactions.length === 0 ? (
            <div className="datatable__no_transactions text-center">
              {noDataText}
            </div>
          ) : (
            this.getTransactionGroup()
          )}
          {transactionsGrid}
          {this.props.showSelectionTag ? (
            <div className="datatable__selection-counts">
              {this.state.mobileRowSelectCount} Selected
              <a
                className="add-tag"
                disabled={this.state.mobileRowSelectCount === 0}
                className={`page-options pull-right ${disableSelectedRowTag}`}
                onClick={this.props.onTableTagClick}
              >
                Add Tag
              </a>
            </div>
          ) : null}
        </div>
      );
    }

    return displayPage;
  }
}
TransactionGridComponentMobile.propTypes = {
  transactions: PropTypes.array,
  loadNextTransactions: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  iconClass: PropTypes.string,
  iconName: PropTypes.string,
  style: PropTypes.string,
  hasIcon: PropTypes.bool,
  showSelectionTag: PropTypes.bool,
  iconPosition: PropTypes.string,
  onRowSelect: PropTypes.func,
  onRowClick: PropTypes.func,
  content: PropTypes.object,
};
// Specifies the default values for props:
TransactionGridComponentMobile.defaultProps = {
  className: 'btn',
  btnName: '',
  hasIcon: false,
  showSelectionTag: false,
};
export default TransactionGridComponentMobile;
